import theme from '../../styles/theme';
export const colors = {
    facebook: 'facebook',
};
export const expandAtSizes = Object.assign({}, theme.breakpointNames);
export const sizes = {
    large: 'large',
    medium: 'medium',
    small: 'small',
};
export const types = {
    destructive: 'destructive',
    destructiveSecondary: 'destructiveSecondary',
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
};
export const iconAlignments = {
    left: 'left',
    right: 'right',
};
